"use strict";

export default {
  setProduct(state, payload) {
    state.products = payload;
  },
};
